import React from "react"
import ArtworkDetailPage from "../../../../features/pages/ArtworkDetailPage"
import ArtworksErrorPage from "../../../../features/pages/ArtworksErrorPage"
import GalleryErrorPage from "../../../../features/pages/GalleryErrorPage"
import galleryApiService from "../../../../services/galleryApiService"
import { idExtractor } from "../../../../services/utils/idExtractor"

const ArtworkDetail = ({
  artworkDetails,
  relatedArtworks,
  errorCode,
  gallery,
  featuredGalleries,
}) => {
  if (errorCode && errorCode !== 200) {
    if (gallery && gallery?.status !== 200) {
      return (
        <GalleryErrorPage
          status={gallery?.status}
          gallery={gallery}
          featuredGalleries={featuredGalleries}
        />
      )
    } else {
      return (
        <ArtworksErrorPage
          status={errorCode}
          artwork={artworkDetails}
          gallery={gallery}
          relatedArtworks={relatedArtworks}
        />
      )
    }
  }

  return (
    <ArtworkDetailPage
      artworkDetails={artworkDetails}
      relatedArtworks={relatedArtworks}
      gallery={gallery}
    />
  )
}

export const getServerSideProps = async ({ params, res, req }) => {
  const { id, artwork } = params
  console.log(`User-Agent: ${req.headers["user-agent"]}`)
  // If given an ID find the domain and redirect
  const isNumericId = /^\d+$/.test(id)
  if (isNumericId) {
    const response = await galleryApiService
      .gallery(id)
      .catch((err) => err.response)

    if (!response || response.data.status !== 200) {
      return {
        props: {
          errorCode: response.data.status || 301,
        },
      }
    }
    return {
      redirect: {
        destination: `/galleries/${response.data.domain}/artworks/${artwork}`,
        permanent: true,
      },
    }
  }

  const gallery_domain = id
  const [artwork_id, ...rest] = idExtractor(artwork)

  try {
    const artworkResponse = await galleryApiService.artwork(artwork_id)
    const galleryResponse = await galleryApiService.galleryByDomain(
      gallery_domain,
    )

    // If the gallery is not available, get the featured galleries
    let featuredGalleries = null
    if (galleryResponse.data.status === 403) {
      try {
        const result = await galleryApiService.featured()
        featuredGalleries = result.data
      } catch (error) {
        console.error("Error fetching featured galleries:", error)
        featuredGalleries = []
      }
    }

    let relatedArtworks = []
    if (galleryResponse.data.status === 200) {
      if (artworkResponse.data?.id) {
        const res = await galleryApiService.relatedArtworks(
          artworkResponse.data?.id,
        )
        relatedArtworks = res.data
      } else {
        const res = await galleryApiService.galleryArtworks(
          galleryResponse.data?.id,
        )
        relatedArtworks = res.data.data
      }
    }

    return {
      props: {
        errorCode: artworkResponse?.data.status,
        artworkDetails: artworkResponse?.data,
        gallery: galleryResponse?.data,
        relatedArtworks: relatedArtworks,
        featuredGalleries: featuredGalleries,
      },
    }
  } catch (error) {
    return { notFound: true }
  }
}

export default ArtworkDetail
